export default __webpack_public_path__ + "static/media/slider_1_3.6e255797.jpg";